@if (toast(); as t) {
  <div class="fixed top-4 left-1/2 -translate-x-1/2 z-50 animate-toast-in">
    <div
      class="flex items-start gap-2.5 rounded-lg border px-4 py-3 shadow-lg text-sm font-medium max-w-sm"
      [class.bg-emerald-50]="t.variant === 'success'"
      [class.border-emerald-200]="t.variant === 'success'"
      [class.text-emerald-800]="t.variant === 'success'"
      [class.bg-red-50]="t.variant === 'error'"
      [class.border-red-200]="t.variant === 'error'"
      [class.text-red-800]="t.variant === 'error'"
      [class.bg-card]="t.variant === 'info'"
      [class.border-border]="t.variant === 'info'"
      [class.text-foreground]="t.variant === 'info'"
    >
      @if (t.variant === 'success') {
        <svg class="w-4 h-4 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 6 9 17l-5-5"/>
        </svg>
      } @else if (t.variant === 'error') {
        <svg class="w-4 h-4 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      } @else {
        <svg class="w-4 h-4 shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
        </svg>
      }
      <span>{{ t.message }}</span>
    </div>
  </div>
}
